import { useEffect } from 'react';

import { useAuth } from '../../hooks';
import { parseUserUrlSearchParams } from '../../utils';

export const PermissionRedirect = (): JSX.Element | null => {
  const { saveUser } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.size === 0) {
      window.location.href = '/redirect-login';
    }

    const { data: UserRedirect, token } = parseUserUrlSearchParams(params);
    UserRedirect.status = UserRedirect.status ?? 'active';

    if (token !== '') {
      localStorage.setItem('JWT_TOKEN', token);
      const originalRoute = params.get('originalRoute') ?? '';
      const shouldUseOriginalRoute = Boolean(
        originalRoute && originalRoute !== '/'
      );
      if (shouldUseOriginalRoute) {
        const existingRoute = localStorage.getItem('originalRoute');
        if (!existingRoute || existingRoute === '/') {
          localStorage.setItem('originalRoute', originalRoute);
        }
        saveUser(UserRedirect, { to: originalRoute, replace: true });
      } else {
        saveUser(UserRedirect);
      }
    }
  }, []);

  return null;
};
